export default __webpack_public_path__ + "static/media/DashAuto.854b3538.svg";